module.exports = __webpack_public_path__ + "static/media/share_4.75decf61.png";